// extracted by mini-css-extract-plugin
export default {"wrapper":"Navigation_wrapper__2i3qf","link":"Navigation_link__QEQJz","enlarge":"Navigation_enlarge__AmhKl","active":"Navigation_active__mY+Gu"};